const config = {
  pageLimit: 20,
  // baseUrl: "http://localhost:8082/api/v1",
  // baseUrl: "http://127.0.0.1:8098/api/v1",
  baseUrl: 'https://www.api.syroltech.com/syrol/api/v1',
  flutterwaveKey: 'FLWPUBK-6212a01350542496a63f70e78fb19640-X',
}
export { config }